"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const PropTypes = tslib_1.__importStar(require("prop-types"));
const React = tslib_1.__importStar(require("react"));
const PopupProvider_1 = tslib_1.__importDefault(require("./PopupProvider"));
const withPopups = () => (ComponentToWrap) => {
    var _a;
    return _a = class ComponentWithPopups extends React.Component {
            render() {
                const { confirm, alert } = this.context;
                return (React.createElement(ComponentToWrap, Object.assign({}, this.props, { confirm: confirm, alert: alert })));
            }
        },
        _a.contextTypes = {
            confirm: PropTypes.func.isRequired,
            alert: PropTypes.func.isRequired,
        },
        _a;
};
exports.default = { withPopups, PopupProvider: PopupProvider_1.default };
